import { inject, Injectable, OnDestroy } from '@angular/core';

import { AccountMessagesService as CoreLabsAccountMessagesService } from '@corelabs/angular/account';
import { MessageService } from '@corelabs/angular/messages';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, tap } from 'rxjs';

@Injectable()
export class AccountMessagesService implements OnDestroy {
    private readonly accountMessagesService = inject(CoreLabsAccountMessagesService);
    private readonly messageService = inject(MessageService);
    private readonly translateService = inject(TranslateService);

    private readonly subscriptions$ = new Subscription();

    constructor() {
        this.subscriptions$.add(
            this.accountMessagesService.messages$
                .pipe(
                    tap((message) => {
                        const translatedMessage = this.translateService.instant(`cl.account.${message.key}`);
                        this.messageService.add(translatedMessage, message.type ?? 'info');
                    }),
                )
                .subscribe(),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions$.unsubscribe();
    }
}
